<div class="dialog-content">
  <div class="close" (click)="elementsCharacterDialogRef.close()"></div>

  <div class="external-wrapper" (click)="elementsCharacterDialogRef.close()"></div>

  <img [src]="image" alt={{name}}>
</div>
